import styled from "styled-components";

// ---------- HEADING ----------

export const StyledDetailPageHeading = styled.h2`
  color: #0e0e2c;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  margin-bottom: 0;
`;

export const StyledPortalHeaderTitle = styled.h3`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`;

export const StyledCardTitle = styled.h3`
  color: var(--GREY, #4a4a68);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
`;

// ---------- SPAN ICON ----------

export const StyledGoBackSpanElement = styled.span`
  align-items: center;
  color: var(--BLUE, #2060ea);
  cursor: pointer;
  display: inline-flex;
  line-height: 0;

  svg {
    display: block;
  }
`;

export const StyledFormControlError = styled.span`
  display: block;
  margin-top: 4px;
  color: #cf324a;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  &.tableDropdown {
    padding-left: 12px !important;
  }
  &.tableInputField {
    font-size: 10px;
    margin-top: 2px;
  }
`;

export const StyledTagLink = styled.a`
  display: inline-flex;
  text-decoration: none;

  &:not(:last-child) {
    margin-right: 8px;
  }
`;

export const StyledDocLink = styled.a`
  color: var(--BLUE, #2060ea);
  cursor: pointer;
`;
